import { ReactNode, Ref } from "react";
import cx from "classnames";

import Box, { BoxProps } from "../../Box";
import styles from "./styles.module.css";

type ActionCardWrapperProps = {
  children: ReactNode;
  className?: string;
  emphasized?: boolean;
  ref?: Ref<HTMLDivElement>;
} & BoxProps;

const ActionCardWrapper = ({
  children,
  className,
  emphasized,
  ...boxProps
}: ActionCardWrapperProps) => {
  return (
    <Box
      shrink="1"
      className={cx(styles.wrapper, emphasized && styles.emphasized, className)}
      {...boxProps}
    >
      {children}
    </Box>
  );
};

ActionCardWrapper.displayName = "DS.ActionCard.Wrapper";

export default ActionCardWrapper;
